/* GOMYART homepage — reveal on scroll, hero image load, review carousel dots. No dependencies. */
(function () {
  if (window.__gmHome) return; window.__gmHome = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function reveal(root) {
    var els = (root || document).querySelectorAll('.gm-rv:not(.is-in)');
    if (!els.length) return;
    if (reduce || design || !('IntersectionObserver' in window)) { els.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (n) { io.observe(n); });
    /* safety sweep: anything already in view after load / bfcache */
    function sweep() { var vh = window.innerHeight; els.forEach(function (n) { if (n.classList.contains('is-in')) return; var r = n.getBoundingClientRect(); if (r.top < vh * 0.95 && r.bottom > 0) n.classList.add('is-in'); }); }
    setTimeout(sweep, 400); setTimeout(sweep, 1500);
    window.addEventListener('pageshow', sweep);
  }

  function hero(root) {
    (root || document).querySelectorAll('.gm-hero').forEach(function (h) {
      var img = h.querySelector('.gm-hero__media img');
      function on() { h.classList.add('is-loaded'); }
      if (!img || img.complete) return on();
      img.addEventListener('load', on, { once: true }); img.addEventListener('error', on, { once: true });
      setTimeout(on, 1800);
    });
  }

  function dots(root) {
    (root || document).querySelectorAll('.gm-rvs').forEach(function (track) {
      var d = track.parentNode.querySelector('.gm-dots'); if (!d || d.children.length) return;
      var items = Array.prototype.slice.call(track.children); if (items.length < 2) return;
      items.forEach(function (c, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
        b.addEventListener('click', function () { track.scrollTo({ left: c.offsetLeft - track.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); });
        d.appendChild(b);
      });
      var btns = Array.prototype.slice.call(d.children), t;
      function mark() { var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity; items.forEach(function (c, i) { var x = Math.abs((c.offsetLeft - track.offsetLeft) + c.offsetWidth / 2 - mid); if (x < dist) { dist = x; best = i; } }); btns.forEach(function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); }); }
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      window.addEventListener('resize', mark); mark();
    });
  }

  function init(root) { hero(root); reveal(root); dots(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  /* theme editor: re-init the section that was re-rendered */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
